import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Sparkles, Users } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { BURGER_I18N } from '../TikTokFeed';
import UserSuggestionsModal, { suggestionTexts } from '../UserSuggestionsModal';

// Découvrir — burger (visible quand l'onglet Accueil est masqué) : Avatar IA + Ajouter des amis.
export const DiscoverBurger = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const B = BURGER_I18N[language] || BURGER_I18N.en;
  const S = suggestionTexts(language);
  return (
    <>
      <button onClick={() => setOpen(true)} className="p-2 hover:scale-110 transition-transform" aria-label="Menu" title="Menu" data-testid="discover-burger-btn">
        <img src="/burger-icon.png" alt="Menu" className="w-10 h-10" />
      </button>
      {open && (
        <div className="fixed inset-0 z-[80] bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center" onClick={() => setOpen(false)} data-testid="discover-burger-menu">
          <div className="w-full sm:max-w-md bg-gray-900 rounded-t-3xl sm:rounded-3xl p-5 border border-white/10" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-bold">{B.title}</h3>
              <button onClick={() => setOpen(false)} className="p-2 hover:bg-white/10 rounded-full" data-testid="discover-burger-close"><X className="w-5 h-5" /></button>
            </div>
            <button onClick={() => { setOpen(false); navigate('/studio'); }} className="text-white w-full mb-3 rounded-2xl bg-gradient-to-br from-fuchsia-600 via-violet-700 to-purple-900 p-5 text-left border border-white/10" data-keep-dark="true" data-testid="discover-burger-avatar-ia">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-2xl bg-white/15 flex items-center justify-center shrink-0"><Sparkles className="w-6 h-6 text-white" /></div>
                <div className="flex-1 min-w-0">
                  <p className="font-bold text-base leading-tight text-white">{B.avaTitle}</p>
                  <p className="text-xs text-white/80 mt-1">{B.avaSub}</p>
                </div>
              </div>
            </button>
            <button onClick={() => { setOpen(false); setShowSuggestions(true); }} className="text-white w-full rounded-2xl bg-gradient-to-br from-yellow-500 via-orange-500 to-fuchsia-600 p-5 text-left border border-white/10" data-keep-dark="true" data-testid="discover-burger-suggestions">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-2xl bg-white/15 flex items-center justify-center shrink-0"><Users className="w-6 h-6 text-white" /></div>
                <div className="flex-1 min-w-0">
                  <p className="font-bold text-base leading-tight text-white">{S.burgerTitle}</p>
                  <p className="text-xs text-white/80 mt-1">{S.burgerSub}</p>
                </div>
              </div>
            </button>
          </div>
        </div>
      )}
      {showSuggestions && <UserSuggestionsModal onClose={() => setShowSuggestions(false)} />}
    </>
  );
};

export default DiscoverBurger;
